"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Avatar.css");

var utils = _interopRequireWildcard(require("../../shared"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Avatar(_ref) {
  var Component = _ref.componentEl,
      avatar = _ref.avatar,
      initials = _ref.initials,
      children = _ref.children,
      className = _ref.className,
      margin = _ref.margin,
      size = _ref.size,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "avatar", "initials", "children", "className", "margin", "size"]);

  // state for image error
  var _useState = (0, _react.useState)(false),
      error = _useState[0],
      setError = _useState[1];

  function onError() {
    setError(true);
  } // given a width and an array of images
  // returns image with closest size to desired width


  function closestImage(width, images) {
    return images.reduce(function (closest, thisone) {
      if (Math.abs(width - thisone.width) < Math.abs(width - closest.width)) {
        return thisone;
      }

      return closest;
    }, images[0]);
  } // if there's no images or a name, don't do anything


  if (!avatar && !initials) return null;
  var cssClasses = ['st_avatar', "st_avatar--" + size];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  var imageAttributes = {};
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });

  if (avatar && typeof avatar === 'string') {
    imageAttributes.src = avatar;
  } else if (avatar && Array.isArray(avatar)) {
    // TODO: read from design tokens!!!
    var sizes = {
      smd: utils.designTokens.SpacerSmd,
      md: utils.designTokens.SpacerMd,
      mlg: utils.designTokens.SpacerMlg,
      lg: utils.designTokens.SpacerLg,
      xl: utils.designTokens.SpacerXl
    };
    var sizedAvatar = closestImage(sizes[size], avatar);
    var sizedAvatar2x = closestImage(sizes[size] * 2, avatar);
    imageAttributes.src = sizedAvatar.url;
    imageAttributes.srcSet = sizedAvatar.url + ", " + sizedAvatar2x.url + " 2x";
  }

  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, avatar && !error && /*#__PURE__*/_react["default"].createElement("img", _extends({
    className: "st_avatar__img"
  }, imageAttributes, {
    loading: "lazy",
    alt: "",
    onError: onError
  })), (!avatar || error) && /*#__PURE__*/_react["default"].createElement("span", {
    className: "st_avatar__letter"
  }, initials)));
}

Avatar.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** array of available avatar images, or url to single image */
  avatar: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].shape({
    width: _propTypes["default"].number,
    url: _propTypes["default"].string
  })), _propTypes["default"].string]),

  /** fallback letter */
  initials: _propTypes["default"].string,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for avatar, if any */
  margin: utils.spacing.marginProps,

  /** size of avatar */
  size: _propTypes["default"].oneOf(['smd', 'md', 'mlg', 'lg', 'xl'])
};
Avatar.defaultProps = {
  componentEl: utils.componentEl.defaults,
  avatar: null,
  initials: null,
  className: null,
  margin: null,
  size: 'mlg'
};
var _default = Avatar;
exports["default"] = _default;